<template>
    <i></i>
</template>

<script lang="ts">
    import { defineComponent } from 'vue';
    import { useI18n } from 'vue-i18n'
    import debounce from "lodash.debounce";

    import { notifySuccess, notifyInfo } from '@/services/notificationService';
    import { translationSegmentService } from './Segment/translationSegmentService';
    import { segmentsEditorService } from './segmentsEditorService';

    export default defineComponent({
        data() {
            return {
                segmentsEditorService: new segmentsEditorService(),
                translationSegmentService: translationSegmentService.getInstance(),
                debouncedGoToNextSegment: null as (() => void) | null,
                debouncedGoToPreviousSegment: null as (() => void) | null,
            }
        },
        setup() {
            const { t } = useI18n()
            return { t }
        },
        mounted() {
            // Initialize debounced navigation functions
            this.debouncedGoToNextSegment = debounce(() => {
                this.segmentsEditorService.goToNextSegment();
            }, 50);
            
            this.debouncedGoToPreviousSegment = debounce(() => {
                this.segmentsEditorService.goToPreviousSegment();
            }, 50);
            
            document.addEventListener("keydown", this.hotkeysListener);
        },
        beforeUnmount() {
            document.removeEventListener("keydown", this.hotkeysListener);
        },
        methods: {
            async hotkeysListener(e: KeyboardEvent) {

                if (e.altKey && e.key === "c") {
                    await this.translationSegmentService.copyCurrentSegment();
                    notifySuccess(this.t('hotkeys.copied'), this.t('hotkeys.sourceCopied'));
                    return
                }

                if (e.altKey && e.key === "t") {
                    await this.translationSegmentService.translateCurrentSegment();
                    notifySuccess(this.t('hotkeys.translated'), this.t('hotkeys.variantsLoadded'));
                    return
                }

                if (e.altKey && e.key === "s") {
                    await this.doAddTranslationWithNotification();
                    return
                }

                if (e.altKey && e.key === "u") {
                    await this.doUpdateTranslationWithNotification();
                    return
                }

                if (e.altKey && e.key === "Backspace") {
                    await this.translationSegmentService.cleanCurrentSegmentTranslationSegment();
                    notifySuccess(this.t('hotkeys.cleared'), this.t('hotkeys.segmentCleared'));
                    return
                }
                               
                if (e.altKey && e.key === "q") {
                    this.translationSegmentService.removeStylesInCurrentSrgment();
                    notifySuccess(this.t('hotkeys.stylesRemoved'), "");
                    return
                }

                if (e.altKey && e.key === "v") {
                    this.translationSegmentService.toogleCurrentSegmentVariantsPopup();
                    return
                }   
                
                if (e.shiftKey && e.key === "Tab") {
                    e.preventDefault();
                    if (this.debouncedGoToPreviousSegment) {
                        this.debouncedGoToPreviousSegment();
                    }
                    return
                }

                if (e.key === "Tab") {
                    e.preventDefault();
                    if (this.debouncedGoToNextSegment) {
                        this.debouncedGoToNextSegment();
                    }
                    return
                }

                if (e.altKey && e.key === "PageUp") {
                    this.segmentsEditorService.goToPreviousPage();
                    return
                }  
                
                if (e.altKey && e.key === "PageDown") {
                    this.segmentsEditorService.goToNextPage();
                    return
                }

                if (e.altKey && e.key === "ArrowRight") {
                    e.preventDefault();
                    await this.doAddTranslationWithNotification();
                    this.segmentsEditorService.goToNextSegment();
                    return
                } 

                if (e.altKey && e.key === "ArrowLeft") {
                    e.preventDefault();
                    await this.doAddTranslationWithNotification();
                    this.segmentsEditorService.goToPreviousSegment();
                    return
                }
                
                if (e.ctrlKey && e.key === "m") {
                    const currentSegment = this.segmentsEditorService.getCurrentSegmentEditorItem();
                    
                    if (this.translationSegmentService.mergeIsPossible(currentSegment) == false){
                        return;
                    }

                    this.segmentsEditorService.statrMerge(currentSegment.itemId);
                    notifyInfo(this.t('hotkeys.mergeBegin'), this.t('hotkeys.mergeDialog'))
                    return
                }

                if (e.ctrlKey && e.shiftKey && e.key === "S") {
                    const currentSegment = this.segmentsEditorService.getCurrentSegmentEditorItem();
                    
                    if (this.translationSegmentService.splitIsPossible(currentSegment) == false){
                        return;
                    }

                    this.segmentsEditorService.statrSplit(currentSegment.itemId);
                    notifyInfo(this.t('hotkeys.splitBegin'), this.t('hotkeys.splitDialog'))
                    return
                }
                
                if (e.altKey && e.key === "n") {
                    notifyInfo(this.t('hotkeys.nextWorkingSegmnet'), "");
                    await this.segmentsEditorService.goToNextWorkSegment();
                    return
                }
            },
            
            async doAddTranslationWithNotification() {
                if(this.translationSegmentService.translationCouldBeAdded()){
                    await this.translationSegmentService.addCurrentSegmentTranslation();
                    notifySuccess(this.t('hotkeys.saved'), this.t('hotkeys.translationSaved'));
                }
            },

            async doUpdateTranslationWithNotification(){
                if(this.translationSegmentService.translationCouldBeUpdated()){
                    await this.translationSegmentService.updateCurrentSegmentTranslation();
                    notifySuccess(this.t('hotkeys.updated'), this.t('hotkeys.translationUpdated'));
                }
            },
        }
    })

</script>